import React from "react";
import { useSelector } from "react-redux";
const Pagination = ({
  currentPage,
  totalPages,
  onPrevious,
  onNext,
}) => {
  const { isPartsURL, isAccessoriesURL, isGodownURL } = useSelector((state) => state.domain);
  return (
    <div className="pagination-container">
      <div className="pagination-info">
        Page {currentPage} of {totalPages}
      </div>
      <div className="pagination-controls">
        <button
          className={`${
            isPartsURL
              ? "pagination-btn-parts"
              : isAccessoriesURL
              ? "pagination-btn-acc"
              : isGodownURL
              ? "pagination-btn-godown"
              : "pagination-btn"
          } ${currentPage === 1 ? 'disabled' : ''}`}
          onClick={onPrevious}
          disabled={currentPage === 1}
        >
          Previous
        </button>
        <button
          className={`${
            isPartsURL
              ? "pagination-btn-next-parts"
              : isAccessoriesURL
              ? "pagination-btn-next-acc"
              : isGodownURL
              ? "pagination-btn-next-godown"
              : "pagination-btn-next"
          }`}
          onClick={onNext}
        >
          Next
        </button>
      </div>
    </div>
  );
};

export default Pagination;
